import Modal from "~/common/components/Modal";
import {
  ACTIONS,
  type GSAPageState,
  useGSAFilterPopupLogic
} from "~/features/selectionAssistant/gearbox/useGearboxSALogic";
import { useTranslation } from "react-i18next";
import {
  useCharacteristicFilterLogic
} from "~/features/selectionAssistant/gearbox/components/CharacteristicsFilter/CharacteristicsFilter";
import {
  getDimensionFilterConfigs
} from "~/features/selectionAssistant/gearbox/components/DimensionsFilter/DimensionsFilter";
import { Button, Stack } from "~/common/mui";

import classes from "~/features/selectionAssistant/gearbox/components/GearboxSelectionAssistantFilterModal.module.less";
import classNames from "classnames";
import { useFetchGearboxSAData } from "~/features/selectionAssistant/gearbox/useFetchGearboxSAData";

interface Props {
  onClose: () => void;
  initialData: any;
  onSubmit: (data: GSAPageState) => void;
}

export const GearboxSelectionAssistantFilterModal = ({ onClose, initialData, onSubmit }: Props) => {
  const { t } = useTranslation();

  const [state, dispatch] = useGSAFilterPopupLogic(initialData);
  useFetchGearboxSAData(state, dispatch, true);

  const { allFilters, renderFilter } = useCharacteristicFilterLogic({
    onChange: (characteristic, value) => dispatch(ACTIONS.updateCharacteristic(characteristic, value)),
    definitions: state.characteristicDefinitions,
    values: state.characteristicValues,
    resultCount: state.resultCount,
  });

  const { configs: dimensionConfigs, renderFilter: renderDimensionFilter } = getDimensionFilterConfigs({
    onChange: (code, value) => dispatch(ACTIONS.updateDimension(code, value)),
    definitions: state.dimensionDefinitions,
    values: state.dimensionValues,
  });

  const submitCb = () => {
    onSubmit(state);
    onClose();
  };

  const resetCb = () => {
    dispatch(ACTIONS.resetAll());
  };

  const footer = (
    <Stack gap={1} direction="row">
      <Button onClick={resetCb} variant={"text"}>
        {t("page.sa.gearbox.modal.btn.reset")}
      </Button>
      <Button onClick={submitCb}>{t("page.sa.gearbox.modal.btn.apply")}</Button>
    </Stack>
  );

  return (
    <Modal
      onClose={onClose}
      modalClassName={classNames(classes.modal)}
      footerChildren={footer}
      title={t("page.sa.gearbox.characteristics.title")}
    >
      <div className={classes.filterList}>{allFilters.map(renderFilter)}</div>
      <h2 className={classes.sectionTitle}>{t("page.sa.gearbox.dimensions.title")}</h2>
      <div className={classes.filterList}>{dimensionConfigs.map(renderDimensionFilter)}</div>
    </Modal>
  );
};
